<template>
  <div class="modal-content !items-center !justify-center relative !w-[calc(100vw-2rem)] min-h-screen sm:!w-[608px] !max-w-[608px]">
    <Loader v-if="loading" />
    <ProductInfoModal v-else-if="product" v-bind="{ product }"/>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Loader from '@/components/shared/loader.vue'
import ProductInfoModal from './product-info-modal.vue'
import { GetBundleProduct, type GetBundleProductQuery } from '@/graphql/queries/product'
import { client } from '@/graphql'
import { gidToId, graphqlUnpack } from '@/utils'
import { imageRef } from '@/graphql/utils/products'
import type { Image } from '@/types/shopify'
import type { BundleProductVariant, GraphqlBundleProduct } from '@/types'


export interface Props {
  bundleProductId: number
}

const props = defineProps<Props>()

const loading = ref(true)
const product = ref()

onMounted(async () => {
  product.value = await loadProduct(props.bundleProductId)
  loading.value = false
})


const loadProduct = async (id: number) => {
  const { data: { product } } = await client.query<GetBundleProductQuery>({
    query: GetBundleProduct,
    variables: {
      id: `gid://shopify/Product/${id}`
    }
  })
  const variants = graphqlUnpack(product.variants.edges) as BundleProductVariant[]
  const sku = variants[0].sku

  const unpackedProduct = {
    ...product,
    sku,
    nid: gidToId(product.id),
    variants,
    images: graphqlUnpack<Image>(product.images.edges),
    flavorForwardImage: imageRef(product.flavorForwardImage),
    nutritionImage: imageRef(product.nutritionImage),
    nutritionFlavorForwardImage: imageRef(product.nutritionFlavorForwardImage),
    zoomImage: imageRef(product.zoomImage),
    ingredients: JSON.parse(product.ingredients?.value ?? '[]')
  } as GraphqlBundleProduct

  return unpackedProduct
}

</script>
